export default __webpack_public_path__ + "mb-close786c64.svg";